import { Box } from '@mui/material'
import type { FC } from 'react'
import FieldErrorList from '../FieldErrorList'

interface ErrorType {
  message: string
  code: string
}

export type ErrorFields<T> = {
  [P in keyof T]: ErrorType[]
}

interface FieldErrorsProps {
  error: ErrorType[] | []
  identifier?: string | null
}

const FieldErrors: FC<FieldErrorsProps> = ({ error, identifier = null }) => {
  let errors
  if (Array.isArray(error) && error.length > 0) {
    errors = (
      <FieldErrorList>
        {error.map((err: ErrorType) => (
          <>
            {typeof err === 'string' ? (
              <li key={identifier ?? err}>{err}</li>
            ) : (
              <li key={identifier ?? err.code}>{err.message}</li>
            )}
          </>
        ))}
      </FieldErrorList>
    )
  }
  return <Box>{errors}</Box>
}

export default FieldErrors
